import { Toaster } from "@/components/ui/sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import SharedResultPage from "@/pages/SharedResultPage";
import SharePage from "@/pages/SharePage";
import BubblePreviewPage from "@/pages/BubblePreviewPage";
import AndroidDownloadPage from "@/pages/AndroidDownloadPage";
import AuthCallback from "@/pages/AuthCallback";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import AdminDashboard from "@/pages/AdminDashboard";
import InstallPrompt from "@/components/InstallPrompt";
import { AuthProvider } from "@/context/AuthContext";

function AppRouter() {
  // CRITICAL: Read the hash from useLocation() so hash removal triggers a re-render.
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/share" element={<SharePage />} />
      <Route path="/check/:cacheKey" element={<SharedResultPage />} />
      <Route path="/bubble-preview" element={<BubblePreviewPage />} />
      <Route path="/android" element={<AndroidDownloadPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <InstallPrompt />
        <Toaster
          position="bottom-right"
          toastOptions={{
            className: "font-mono-plex text-[11px]",
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
